module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAS0lEQVR42s3SsQkAMAhE0dPhHNrlTCGI2Oh1sf6PEBOJCDCjIIcDZqZUTZyQ9RVUfQK93sGod+Du9FqHOV26m+tayxAPl0Y++3wAHgCQFetcmV1EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/pointer.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/pointer.png
// module chunks = styles